import { Link as ExternalLink } from "@trussworks/react-uswds";
import { useTranslation } from "react-i18next";
import { ReactComponent as DirectionsIcon } from "../../images/directions.svg";
import { V1Clinic } from "../../types/v1_schemas";

function DirectionsLink({
  v1Clinic,
}: {
  v1Clinic: V1Clinic | undefined;
}) {
  const { t } = useTranslation();

  let thisClinic:V1Clinic | undefined = v1Clinic;
  let address = null;

  if (thisClinic) {
    let hasAddress = thisClinic.clinicLocations?.filter((value => value.latitude && value.longitude));
    if (hasAddress) {
      address = (hasAddress[0]?.addressLine1 ?? '' )
                + ", " 
                + (hasAddress[0]?.cityText?.length ? hasAddress[0].cityText : '')  
                + ", CO " 
                + (hasAddress[0]?.postalCode?.length ? hasAddress[0].postalCode : '');
      //let t = address;          
}
  }

  if (!address) {
    return null;
  }
  else {
    const googleMapsDirectionsURL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    address
  )}`;

  return (
    <ExternalLink
      className="usa-button margin-right-0 display-flex flex-align-center flex-justify-center"
      style={{backgroundColor:'#F7F8F8'}}
      target="_blank "
      href={googleMapsDirectionsURL}
    >
      <DirectionsIcon className="margin-right-1" />
      <span className="nice_font" style={{color: '#1E6692'}}>{t("getDirections")}</span>
    </ExternalLink>
  );
    }
}

export default DirectionsLink;
